import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-left-thin",
  "use": "icon-chevron-left-thin-usage",
  "viewBox": "0 0 16 28",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 28\" id=\"icon-chevron-left-thin\">\r\n<polygon id=\"icon-chevron-left-thin_Page-1\" points=\"14.3,28 15.8,26.6 2.9,14 2.9,14 2.9,14 15.8,1.4 14.3,0 1.4,12.6 0,14 0,14 0.8,14.8 \" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/chevron-left-thin.svg
// module id = 273
// module chunks = 0 1